import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoAlertCheckGrn = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.00004 17.6667C13.7865 17.6667 17.6667 13.7865 17.6667 9.00004C17.6667 4.21357 13.7865 0.333374 9.00004 0.333374C4.21357 0.333374 0.333374 4.21357 0.333374 9.00004C0.333374 13.7865 4.21357 17.6667 9.00004 17.6667ZM14.4328 6.31964C14.5685 6.45676 14.6364 6.62325 14.6364 6.81914C14.6364 7.01502 14.5685 7.18151 14.4328 7.31863L8.17822 13.6357C8.04246 13.7729 7.87762 13.8414 7.68368 13.8414C7.48974 13.8414 7.32489 13.7729 7.18913 13.6357L3.56731 9.97769C3.43155 9.84058 3.36368 9.67408 3.36368 9.4782C3.36368 9.28232 3.43155 9.11582 3.56731 8.97871L4.5564 7.97972C4.69216 7.84261 4.85701 7.77405 5.05095 7.77405C5.24489 7.77405 5.40974 7.84261 5.54549 7.97972L7.68368 10.1466L12.4546 5.32066C12.5903 5.18354 12.7552 5.11498 12.9491 5.11498C13.1431 5.11498 13.3079 5.18354 13.4437 5.32066L14.4328 6.31964Z"
	})]
});
const ForwardRef = forwardRef(SvgIcoAlertCheckGrn);
export { ForwardRef as ReactComponent };
